export default __webpack_public_path__ + "static/media/github.77e22da5.svg";